jQuery(document).ready(function( $ ){
	// START JQUERY
	logit = (typeof logit !== 'undefined')? logit : false;

	filter_cards_enable = (typeof filter_cards_enable !== 'undefined')? filter_cards_enable : true;
	filter_cards_filter = (typeof filter_cards_filter !== 'undefined')? filter_cards_filter : true;
	filter_cards_class = (typeof filter_cards_class !== 'undefined')? filter_cards_class : '.card-filter';
	filter_cards_attribute = (typeof filter_cards_attribute !== 'undefined')? filter_cards_attribute : 'data-card-filter';
	filter_cards_hide = (typeof filter_cards_hide !== 'undefined')? filter_cards_hide : false;
	filter_cards_class_active = (typeof filter_cards_class_active !== 'undefined')? filter_cards_class_active : 'active';
	filter_cards_class_hidden = (typeof filter_cards_class_hidden !== 'undefined')? filter_cards_class_hidden : 'd-none';
	filter_cards_class_disabled = (typeof filter_cards_class_disabled !== 'undefined')? filter_cards_class_disabled : 'opacity-25';


	// SCROLLSPY
	if(filter_cards_enable) {
		if(logit) console.log('[FILTER CARDS] Enabled' + filter_cards_class);
//		if(logit == 2) console.log('[FILTER CARDS] target: ' + scrollspy_target + ', offset: ' + scrollspy_offset + ' smooth: ' + scrollspy_smooth);

			function filterCards(filter=false) {
				if(filter) {
					if(logit) console.log('[FILTER CARDS] Filtering:' + filter);

					$(filter_cards_class).each(function(){
							tags = $(this).attr(filter_cards_attribute);
							tags.replace(/\,$/, '');
							var tagsArr = tags.split(",");
							if(jQuery.inArray(filter,tagsArr) > -1){
								 $(this).addClass(filter_cards_class_active);
								 $(this).removeClass(filter_cards_class_hidden);
								 $(this).removeClass(filter_cards_class_disabled);
							} else {
								$(this).removeClass(filter_cards_class_active);
								if(filter_cards_hide)	$(this).addClass(filter_cards_class_hidden);
								$(this).addClass(filter_cards_class_disabled);
							}
					});



				} else {
					if(logit) console.log('[FILTER CARDS] Reseting!');
					$(filter_cards_class).removeClass(filter_cards_class_active);
					$(filter_cards_class).removeClass(filter_cards_class_hidden);
					$(filter_cards_class).removeClass(filter_cards_class_disabled);
				}
			}



			if(filter_cards_filter) {
				filterCards(filter_cards_filter);
		 }

} else {
	if(logit == 2) console.log('[FILTER CARDS] Disabled');

}



	// END JQUERY
});
